import { useEffect } from 'react'
import { authService } from '../services/auth'

interface KeycloakAuth {
  keycloak: {
    updateToken: (_minValidity: number) => Promise<boolean>
    onTokenExpired?: () => void
  }
}

export const useTokenRefresh = () => {
  useEffect(() => {
    // Only set up refresh for Keycloak auth (not mocks)
    if (!authService.isAuthenticated() || !('keycloak' in authService)) {
      return
    }

    const keycloakAuth = authService as KeycloakAuth
    const keycloak = keycloakAuth.keycloak

    if (!keycloak) {
      return
    }

    // Set up automatic token refresh before expiration
    keycloak.onTokenExpired = () => {
      console.log('Token expired, attempting refresh...')
      keycloak.updateToken(30).then((refreshed) => {
        console.log('Token refresh result:', refreshed)
      }).catch((error) => {
        console.error('Token refresh failed:', error)
      })
    }

    return () => {
      if (keycloak) {
        keycloak.onTokenExpired = undefined
      }
    }
  }, [])
}
